


import React, { useEffect } from "react";
import { Label } from "../../../../Components/ui/label";
import {
  Accordion,
} from "../../../../Components/ui/accordion";
import CountryRoamingDaysAccordion from "../Components/CountryRoamingDaysAccordion"
import { useCampaignContext } from "../CampaignContext";
import { useSelector } from "react-redux";
import { RootState } from "@/src/State/store";

interface RoamingDaysSectionProps {
  isViewMode: boolean;
}

const RoamingDaysSection: React.FC<RoamingDaysSectionProps> = ({ isViewMode }) => {
  const {
    roamingDaysByCountry,
    setRoamingDaysByCountry,
    fromCountryISOs,
    fromCountries,
  } = useCampaignContext();

  const selectedFromCountryISOs = useSelector(
    (state: RootState) => state.advertiserAccount.selectedFromCountryISOs
  );

  const initializeRoamingDaysForCountry = (iso: string) => {
    return {
      condition_a: { con_operator: ">=", value: 1 },
      condition_b: { con_operator: "<=", value: 30 },
    };
  };

  useEffect(() => {
    if (!fromCountries || fromCountries.length === 0) {
      setRoamingDaysByCountry({});
      return;
    }

    const currentISOs = selectedFromCountryISOs || [];
    const existingISOs = Object.keys(roamingDaysByCountry);

    const isosToAdd = currentISOs.filter((iso) => !existingISOs.includes(iso));
    const isosToRemove = existingISOs.filter((iso) => !currentISOs.includes(iso));

    if (isosToAdd.length > 0 || isosToRemove.length > 0) {
      setRoamingDaysByCountry((prev) => {
        const updated = { ...prev };

        isosToAdd.forEach((iso) => {
          updated[iso] = initializeRoamingDaysForCountry(iso);
        });

        isosToRemove.forEach((iso) => {
          delete updated[iso];
        });

        return updated;
      });
    }
  }, [selectedFromCountryISOs, fromCountries]);

  const handleCountryRoamingDayUpdate = (
    iso: string,
    config: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    }
  ) => {
    setRoamingDaysByCountry((prev) => ({
      ...prev,
      [iso]: config,
    }));
  };

  if (!fromCountries || fromCountries.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <Label
        className="font-medium text-[#020617]"
        style={{ fontSize: "14px" }}
      >
        Roaming Days
      </Label>

      <div className="mt-1 border rounded-md px-3 py-1">
        <Accordion type="multiple" className="w-full">
          {fromCountries.map((countryName) => {
            const countryISO = fromCountryISOs[countryName];
            const roamingConfig = roamingDaysByCountry[countryISO];

            if (!countryISO || !roamingConfig) {
              return null;
            }

            return (
              <CountryRoamingDaysAccordion
                key={countryISO}
                countryName={countryName}
                countryISO={countryISO}
                roamingDayConfig={roamingConfig}
                onUpdate={handleCountryRoamingDayUpdate}
                isViewMode={isViewMode}
              />
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default RoamingDaysSection;